import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import Tilt3D from "./Tilt3D";

const TILES = [
  { name: "Perfumes", image: "/brand/atw-signature.jpg", span: "md:col-span-2 md:row-span-2", count: "05 scents" },
  { name: "Watches", image: "/brand/products/sovereign-chronograph.jpg", span: "", count: "03 pieces" },
  { name: "Shirts", image: "/brand/looks/ivory-poplin-v4.jpg", span: "", count: "03 pieces", pos: "50% 15%" },
  { name: "Trousers", image: "/brand/looks/tailored-wool-v4.jpg", span: "md:row-span-2", count: "03 pieces", pos: "50% 30%" },
  { name: "Polos", image: "/brand/looks/signature-pique-v4.jpg", span: "", count: "03 pieces", pos: "50% 15%" },
  { name: "Candles", image: "/brand/products/amber-noir.jpg", span: "md:col-span-2", count: "02 pieces" },
  { name: "Belts", image: "/brand/products/tan-artisan.jpg", span: "", count: "02 pieces" },
];

export default function Collections() {
  return (
    <section data-testid="collections-section" className="relative py-20 md:py-28 px-6 lg:px-12 bg-coal text-ivory overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_85%_20%,rgba(212,175,55,0.12),transparent_50%)] pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-10 md:mb-14">
          <Reveal>
            <p className="text-[10px] md:text-xs tracking-[0.5em] uppercase gold-text mb-5">Seven Worlds</p>
            <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-none">The <span className="italic gold-text">Collections</span></h2>
          </Reveal>
          <Reveal delay={0.15}>
            <Link to="/shop" data-testid="collections-view-all-link" className="group flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase text-ivory/60 hover:text-gold-light transition-colors duration-300">
              View everything
              <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[250px] gap-3 md:gap-5">
          {TILES.map((tile, i) => (
            <motion.div
              key={tile.name}
              initial={{ opacity: 0, rotateY: i % 2 ? 28 : -28, x: i % 2 ? 50 : -50 }}
              whileInView={{ opacity: 1, rotateY: 0, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 1, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              style={{ transformPerspective: 1200 }}
              className={tile.span}
            >
              <Tilt3D max={7} scale={1.01} className="h-full w-full gold-glow-hover">
                <Link to={`/shop?cat=${encodeURIComponent(tile.name)}`} data-testid={`collection-tile-${tile.name.toLowerCase()}`} className="relative block h-full w-full overflow-hidden bg-obsidian">
                  <img src={tile.image} alt={tile.name} loading="lazy" style={{ objectPosition: tile.pos }} className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-obsidian/20 to-transparent" />
                  <div className="absolute inset-0 border border-gold/0 group-hover:border-gold/60 transition-colors duration-500" />
                  <div style={{ transform: "translateZ(40px)" }} className="absolute bottom-0 left-0 right-0 p-5 md:p-6 flex items-end justify-between text-ivory">
                    <div>
                      <p className="text-[9px] tracking-[0.3em] uppercase text-gold-light/70">{tile.count}</p>
                      <span className="font-serif text-xl md:text-2xl tracking-wide">{tile.name}</span>
                    </div>
                    <ArrowUpRight size={18} className="text-gold-light opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-[opacity,transform] duration-500" />
                  </div>
                </Link>
              </Tilt3D>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
